// Speculation Rules for prefetching pages
// See: https://developer.mozilla.org/en-US/docs/Web/API/Speculation_Rules_API
import type { SpeculationRules } from "../types/speculation-rules.types";

/** Creates a script element with the given content */
export function createSpeculationRules<T extends SpeculationRules>(s: T) {
  // Check if the Speculation Rules API is supported
  if (HTMLScriptElement.supports && HTMLScriptElement.supports("speculationrules")) {
    const script = document.createElement("script");
    script.type = "speculationrules";
    script.textContent = JSON.stringify(s);
    document.head.append(script);
  }
}
